<template>
    <div class="c-match-handicap morebeteg" :id="'cmatch'+event.eveid">
      <div class="vrow no-wrap">
        <template v-for="col in 5">
            <div class="handicap-col">
                <!-- <template v-for="(count, index) in 2"> -->
                    <template v-for="row in 20">
                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn + 'px !important' }">
                            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-eg-'+ftPlyType">
                                <div class="handicap-value color-highlight" style="justify-content: flex-start; margin-left: 25px;">
                                    <span class="handicap-more" style="display: none;">&nbsp;</span>
                                    <div class="handicap-value-text">{{ getCount(row, col, '-') }}</div>
                                </div>
                                <oddEdg :event="event" :score="getCount(row, col, 'od')" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" :ref="getCount(row, col, 'teamod')" :mode="'morebet'" />
                            </div>
                        </div>
                    </template>
                <!-- </template> -->
            </div>
        </template>
      </div>
      <div class="box_innbet_btn" @click="moreBtnHandle(event.eveid)">
        <div :id="'pd_show_more_'+event.eveid" :data-less="sportAllBetLang['ALL_BET.LBL_VIEW_LESS']" :data-more="sportAllBetLang['ALL_BET.LBL_VIEW_MORE']" class="btn_innbet_more">
          <i class="icon-arrow q-icon c-icon"><svg><use xlink:href="#icon_toparr"></use></svg></i>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {
    mapGetters,
  } from 'vuex'
  import allBetMixin from '../../../mixins/allBet'
  
  export default {
    mixins: [allBetMixin],
    props: {
      // allBetEvent: null,
      event: null,
    //   plytyp: null,
    //   selectMarket: null,
    //   removeMarket: null,
    //   rbinfo: null,
    //   myMarket: {
    //     type: Boolean,
    //     default: false
    //   },
    //   isSpecial: {
    //     type: Boolean,
    //     default: false
    //   },
      widthColumn:null,
      isUnfold:false
    },
    computed: {
      ...mapGetters([
        // 'mainMarketBet',
        // 'selectedShow',
        // 'moreBetLoading',
        'sportAllBetLang',
      ]),
    },
    data() {
      return {
        btypes: [allBetMixin.data().edgBetType],
        // show: true,
        // mainMarketList: null,
        bettype: allBetMixin.data().edgBetType,
      }
    },
    methods: {
        getCount(row, col, type){
            const total = (col - 1) * 20 + row - 1;
            const xCount = Math.floor(total / 10);
            const yCount = total % 10;
            let result = xCount;
            switch (type) {
                case 'x':
                    result = xCount;
                    break;
                case 'y':
                    result = xCount;
                    break;
                case '-':
                    result = `${xCount} - ${yCount}`;
                    break;
                default:
                    result = `${type}${xCount}${yCount}`;
                    break;
            }
            return result;
        },
        // getScoreName(col,count,row,symbol='') {
        //     return (parseInt(col)+parseInt(count)).toString() + symbol + (row).toString()
        // },
        moreBtnHandle(eveid) {
          var oriMoreBetHeight = this.$parent.$refs['moreBetmatches'+eveid].offsetHeight
          if($('#cmatch'+eveid+' .box_innbet_btn').hasClass('open')) {
            $('#cmatch'+eveid+' .box_innbet_btn').removeClass('open')
            $('body .yb-match-list .c-match-item #cmatch'+eveid+'.c-match-handicap.morebeteg .handicap-col .bet-item-wrap:nth-of-type(n+6)').css('display','none')
          } else {
            $('#cmatch'+eveid+' .box_innbet_btn').addClass('open')
            $('body .yb-match-list .c-match-item #cmatch'+eveid+'.c-match-handicap.morebeteg .handicap-col .bet-item-wrap:nth-of-type(n+6)').css('display','block')
          }
          var afterMoreBetHeight = this.$parent.$refs['moreBetmatches'+eveid].offsetHeight
          var offset = afterMoreBetHeight - oriMoreBetHeight
          var xParent1 = this.$parent.$parent.$refs['eCardWrap'+eveid]
          var xParent2 = this.$parent.$parent.$refs['eCard'+eveid]
          var xParent1Height = (xParent1 && xParent1.length > 0)? xParent1[0].offsetHeight:xParent1.offsetHeight  //285
          var xParent2Height = (xParent2 && xParent2.length > 0)? xParent2[0].offsetHeight:xParent2.offsetHeight //285
          // this.childHeight = this.$refs['moreBetmatches'+eveid].offsetHeight + mbetHeader
          var p1 = xParent1Height + offset
          var p2 = xParent2Height + offset
          document.getElementById('eCardWrap'+eveid).style.height = p1+"px";
          document.getElementById('eCard'+eveid).style.height = p2+"px";
        }
    },
    beforeMount() {
    },
  }
  </script>
  


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/moreBet-eg.vue